import { Component, computed, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Slide } from '../../Type/okeeycash-slide.interface';

@Component({
  selector: 'slide-control',
  imports: [TranslateModule],
  templateUrl: './slide-control.component.html',
  styleUrl: './slide-control.component.scss'
})
export class SlideControlComponent {
  private readonly router = inject(Router);

  readonly slides = input.required<Slide[]>();
  readonly activeSlideIndex = input.required<number>();
  readonly isPrevDisabled = input.required<boolean>();
  readonly isNextDisabled = input.required<boolean>();
  readonly routerUrl = input.required<string>();
  readonly goToSlide = output<number>();
  readonly onPrevClick = output<void>();
  readonly onNextClick = output<void>();

  readonly isTutorial = computed(() => this.routerUrl().includes('tutorial'));
  readonly isJourney = computed(() => this.routerUrl().includes('journey'));

  preventEvent(event: Event): void {
    event.stopPropagation();
  }

  goToOkeeyCash(): void {
    void this.router.navigate(['workspace', 'my-okeey-cash']);
  }
}
